import { useGetOrganizationsQuery } from "@crowdcoursing/api/graphql";
import { useMemo } from "react";

export const useOrganizations = () => {
  const {
    data: organizationsData,
    isLoading: isOrganizationsLoading,
    error: organizationsError,
    refetch,
  } = useGetOrganizationsQuery();

  const organizations = useMemo(() => {
    if (!organizationsData?.organizations) {
      return [];
    }
    return organizationsData.organizations.map((org) => {
      const type = org.type ?? "";
      return {
        address: org.address,
        bubbleId: org.bubbleId ?? undefined,
        canCreateEvents: true,
        description: org.description,
        id: org.id,
        isExternal: type === "Organization",
        name: org.name,
        organizationType: org.type ?? null,
        slug: org.slug ?? undefined,
      };
    });
  }, [organizationsData?.organizations]);

  return {
    error: organizationsError,
    isLoading: isOrganizationsLoading,
    organizations,
    refetch,
  };
};
